class Pagination {

	constructor() {
		this.init();
    this.mobile();
	}

	init() {

  }

  mobile(){
    $(document).on('click', '#mobile-pagination-load-more', function(){
      var button = $(this),
          paged = $(this).data('paged'),
          max_num_pages = $(this).data('max_num_pages'),
          data = { action: 'load_more_posts' };

      if(button.hasClass('disabled')) return; // make sure to return so we cannot load more on disabled
      if(button.hasClass('loading')) return; // make sure to return so we cannot load more when it's already fetching

      // add to paged
      button.data('paged', paged + 1);
      paged++;
      data.paged = paged;

      // add loading class
      button.addClass('loading');

      // check for cat, search, render_type, and post_type
      if(button.data('cat')) data.cat = button.data('cat');
      if(button.data('search')) data.search = button.data('search');
      if(button.data('post_type')) data.post_type = button.data('post_type');
      if(button.data('render_type')) data.render_type = button.data('render_type');

      // if paged is equal to max_num_pages, add disabled class to prevent future clicks
      if(paged == max_num_pages) button.addClass('disabled');

      $.ajax({
        type : 'post',
				dataType : 'json',
				url : variables.ajax_url,
				data : data,
				success: function(response) {
					console.log(response);
          button.removeClass('loading');
          $('.pagination-mobile-ajax-load-parent').removeClass('d-none').find('.pagination-mobile-ajax-load-destination').append(response.html);
        }
      });
    });
  }
}

export default Pagination;
